import Chart from "react-apexcharts";
import Card from "../components/DataCleaning/Card";
import Title from "../components/title";
import OverlayLoading from "../components/OverlayLoading";
import { useMemo, useState } from "react";
import {
  faClone,
  faPercentage,
  faWarning,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { colors } from "../global";
import GeoRender from "../components/DataCleaning/GeoRender";
import DetailModal from "../components/DataCleaning/DetailModal";

const DataCleaning = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [previewModalTitle, setPreviewModalTitle] = useState(null);
  const openMinorErrorInfo = () => {
    setIsPreviewModal(true);
    setPreviewModalTitle("Minor Error Data");
  };
  const openMajorErrorInfo = () => {
    setIsPreviewModal(true);
    setPreviewModalTitle("Major Error Data");
  };

  const openDuplicatedDataInfo = () => {
    setIsPreviewModal(true);
    setPreviewModalTitle("Duplicated Data");
  };

  const closeModal = () => {
    setIsPreviewModal(false);
  };
  const fromChartConfig = useMemo(
    () => ({
      series: [5967, 4132, 3469, 1406, 1308, 428, 208, 189, 5],
      options: {
        chart: {
          type: "donut",
        },
        title: {
          text: "From State Breakdown",
          align: "center",
          style: {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333",
          },
        },
        labels: ["NSW", "VIC", "QLD", "WA", "SA", "ACT", "NT", "TAS", "#N/A"],
        colors: ["#144677", "#1a5c99", "#FF6266", "#6b7280", "#ef4444"],
        legend: {
          position: "right",
          labels: {
            colors: "#666",
          },
        },
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString(),
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    }),
    []
  );
  const toChartConfig = useMemo(
    () => ({
      series: [16892, 0.0001],
      options: {
        chart: {
          type: "donut",
        },
        title: {
          text: "To State: NSW",
          align: "center",
          style: {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333",
          },
        },
        labels: ["NSW", "Other"],
        colors: ["#144677", "#1a5c99"],
        tooltip: {
          y: {
            formatter: (val) => val.toLocaleString(),
          },
        },
        legend: {
          position: "right",
          labels: {
            colors: "#666",
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 250,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    }),
    []
  );

  const topLaneChartConfig = useMemo(
    () => ({
      series: [
        {
          name: "Total Consignments",
          data: [3343, 2684, 1531, 1162, 1103],
        },
      ],
      options: {
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            // show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: "50%",
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => val.toLocaleString(),
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#444"],
          },
        },
        xaxis: {
          categories: [
            "SYD1-SYD1",
            "SYD1-MEL1",
            "SYD1-BNE",
            "SYD1-SEQLD",
            "SYD1-ADL",
          ],
          position: "bottom",
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            rotate: -30,
            style: {
              fontSize: "12px",
            },
          },
          tooltip: {
            enabled: true,
          },
        },
        yaxis: {
          title: {
            text: "Total Consignments",
            style: {
              fontSize: "14px",
            },
          },
          labels: {
            formatter: (val) => val.toLocaleString(),
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val.toLocaleString()} consignments`,
          },
        },
        title: {
          text: "Top 5 Lanes by Total Consignments",
          align: "center",
          margin: 20,
          offsetY: 10,
          style: {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#333",
          },
        },
        grid: {
          borderColor: "#f1f1f1",
          padding: {
            bottom: 20,
          },
        },
        colors: ["#144677"],
      },
    }),
    []
  );

  const carrierBarChart = {
    series: [
      {
        name: "Consignments",
        data: [11284, 5606, 2],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 6,
          barHeight: "60%",
          dataLabels: {
            position: "right",
          },
        },
      },
      title: {
        text: "Carrier Consignment Volume",
        align: "left",
        style: {
          fontSize: "16px",
          fontWeight: "bold",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val.toLocaleString(),
        offsetX: 20,
        style: {
          colors: ["#000"],
          fontSize: "12px",
          fontWeight: "bold",
        },
      },
      xaxis: {
        categories: ["STARTRACK EXP", "DIRECT FRT", "FASTWAY"],
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      tooltip: {
        y: {
          formatter: (val) => `${val.toLocaleString()} consignments`,
        },
      },
      colors: ["#144677"],
    },
  };

  const consignmentChart = {
    series: [
      {
        name: "Total Consignment",
        data: [10774, 5964, 140, 13, 1],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          borderRadius: 6,
          columnWidth: "50%",
          dataLabels: {
            position: "top",
          },
        },
      },
      title: {
        text: "From State - Total Consignment",
        align: "center",
        style: {
          fontSize: "16px",
          fontWeight: "bold",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => val.toLocaleString(),
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#444"],
        },
      },
      xaxis: {
        categories: ["Satchel", "Catron", "Skid", "Pallet", "OS Pallet"],
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        title: {
          text: "Total Consignment",
        },
      },
      tooltip: {
        y: {
          formatter: (val) => `${val.toLocaleString()} consignments`,
        },
      },
      colors: ["#144677"],
    },
  };

  const cardData = [
    {
      data: "95%",
      title: "Percentages",
      icon: faPercentage,
      variant: "default",
      description: "Percentage of clean data",
    },
    {
      data: "10",
      title: "Duplicated Data",
      icon: faClone,
      variant: "accent",
      description: "Number of duplicated records",
      onClick: openDuplicatedDataInfo,
    },
    {
      data: "80",
      title: "Minor Error Data",
      icon: faWarning,
      variant: "warning",
      description: "Count of minor data errors",
      onClick: openMinorErrorInfo,
    },
    {
      data: "50",
      title: "Major Error Data",
      icon: faXmark,
      variant: "accent",
      //   trend: { type: "up", value: "+2.1%" },
      description: "Count of major data errors",
      onClick: openMajorErrorInfo,
    },
  ];

  return (
    <>
      {isPreviewModal && (
        <DetailModal closeModal={closeModal} title={previewModalTitle} />
      )}
      {isSubmitting && (
        <OverlayLoading
          isVisible={isSubmitting}
          message="Processing your request..."
          icon="truck"
        />
      )}

      <div className="p-6 pb-0">
        <div className="p-6 bg-gray-100 rounded-lg">
          <div className="">
            <Title title="Data Cleaning" />
          </div>
        </div>
        <div className="mt-8 bg-white rounded-lg shadow p-4">
          <div className="mb-3">
            <h1
              className="text-3xl font-bold"
              style={{ color: colors.primary }}
            >
              Data Cleaning Summary
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              This is the summary of data check
            </p>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {cardData.map((card, index) => (
              <Card
                key={index}
                data={card.data}
                title={card.title}
                icon={card.icon}
                variant={card.variant}
                trend={card.trend}
                description={card.description}
                {...(card.onClick && { onClick: () => card.onClick() })}
              />
            ))}
          </div>
        </div>

        <div className="mt-8 bg-white rounded-lg shadow p-4">
          <p className="text-xl font-semibold mb-4">Chart Overview</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <GeoRender
              geoData={{
                "New South Wales": 5967,
                Victoria: 4132,
                Queensland: 3469,
                "Western Australia": 1406,
                "South Australia": 1308,
                "Australian Capital Territory": 428,
                "Northern Territory": 208,
                Tasmania: 189,
                "#N/A": 5,
              }}
              geoFileUrl="/data/australian-states.min.geojson"
              regionNameKey="STATE_NAME"
              mapName="australia"
              title="From State Breakdown"
              colorRange={["#FFE5E6", "#FF999B", "#FF6266"]}
            />
            <GeoRender
              geoData={{
                "New South Wales": 16892,
              }}
              geoFileUrl="/data/australian-states.min.geojson"
              regionNameKey="STATE_NAME"
              mapName="australia"
              title="To State Breakdown"
              colorRange={["#73A9FF", "#3D6FCC", "#144677"]}
            />
            <Chart
              options={topLaneChartConfig.options}
              series={topLaneChartConfig.series}
              type="bar"
              height={350}
            />
            <Chart
              options={carrierBarChart.options}
              series={carrierBarChart.series}
              type="bar"
              height={350}
            />

            <Chart
              options={consignmentChart.options}
              series={consignmentChart.series}
              type="bar"
              height={350}
            />
            <Chart
              options={fromChartConfig.options}
              series={fromChartConfig.series}
              type="donut"
              width="380"
            />
            <Chart
              options={toChartConfig.options}
              series={toChartConfig.series}
              type="donut"
              width="380"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DataCleaning;
